//接口请求地址
export default {
    // serverURL: "http://47.103.103.17:11100/",
    // newsURL:"http://47.103.103.17:10100/",
    serverURL: "http://101.132.106.62:11100/",
    newsURL: "https://smartxiantao.com/",
    oasisURL:"https://em.renrbang.com",
    rrbURL:"https://zhxt.renrbang.com/NRBService/",

    // mapConfigList:[{
    //     index:0,
    //     name:"房县醉房陵黄酒有限公司",
    //     position:"110.562501,32.053017",
    //     address:"十堰市房县华龙堰镇化龙村6组"
    // },{
    //     index:1,
    //     name:"北京忠和房县生物食品有限公司",
    //     position:"110.761416,32.049804",
    //     address:"湖北省十堰市房县城关镇沿河路9号"
    // },{
    //     index:2,
    //     name:"房县唐宫宴酒业有限公司",
    //     position:"110.768871,32.081003",
    //     address:"湖北省十堰市房县神农皇酒产业园（房县白鹤镇长龙堰村）"
    // },{
    //     index:3,
    //     name:"房县土城白茅家酿服务专业合作社",
    //     position:"110.692394,32.258706",
    //     address:"房县土城镇土城村"
    // },{
    //     index:4,
    //     name:"房县耕秦原始农业发展有限公司",
    //     position:"110.451664,32.00762",
    //     address:"十堰市房县门古寺镇"
    // },{
    //     index:5,
    //     name:"湖北房县庐陵三多黄酒有限公司",
    //     position:"110.748962,32.058275",
    //     address:"湖北省十堰市房县城关镇东大街324号"
    // },{
    //     index:6,
    //     name:"房县野人泉酒业有限公司",
    //     position:"110.70423,32.059037",
    //     address:"湖北省十堰市房县红塔乡七河村"
    // },{
    //     index:7,
    //     name:"房县神农泉酒业有限公司",
    //     position:"110.720448,32.106122",
    //     address:"湖北省十堰市房县红塔镇谢湾村5组"
    // },{
    //     index:8,
    //     name:"房县炎帝仙草黄酒厂",
    //     position:"110.760653,32.046456",
    //     address:"湖北省十堰市房县城关镇房陵大道38号"
    // },{
    //     index:9,
    //     name:"湖北房县兴祥黄酒有限公司",
    //     position:"110.768871,32.081003",
    //     address:"神农皇酒产业园（房县白鹤镇长龙堰村）"
    // },{
    //     index:10,
    //     name:"十堰房州贡品酒庄有限公司",
    //     position:"110.781445,32.105061",
    //     address:"湖北省十堰市房县白鹤镇伏溪堰村4组"
    // },{
    //     index:11,
    //     name:"湖北庐陵王酒业有限责任公司",
    //     position:"110.795316,32.63982",
    //     address:"湖北省十堰市房县城关镇白土村一组"
    // },{
    //     index:12,
    //     name:"湖北古朗源酒业有限公司",
    //     position:"110.740828,32.082066",
    //     address:"十堰市房县城关镇迎宾大道191号"
    // },{
    //     index:13,
    //     name:"湖北多跃农业发展有限公司",
    //     position:"110.76674,32.04685",
    //     address:"湖北省十堰市房县城关镇桃园村9组"
    // },{
    //     index:14,
    //     name:"湖北青峰啤酒有限责任公司",
    //     position:"110.974089,32.04394",
    //     address:"湖北省十堰市房县青峰镇青峰村5组"
    // }]
};